// extracted by mini-css-extract-plugin
module.exports = {"columnGroupContainer":"renderColumns_columnGroupContainer__1l4D8"};